import React, { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";

import * as actions from "../../../store/actions/";
import { VALIDATE_RESET_PASSWORD } from "../../../store/actions/actionTypes";
import { getRegPath } from "../../../constants";

import Row from "../../../components/uiElements/grid/Row";
import Button from "../../../components/formElements/button/Button";
import TextInput from "../../../components/formElements/input/TextInput";
import SpinnerBorder from "../../../components/uiElements/loadingSpinner/SpinnerBorder";

const ResetPassword = ({
  resetPasswordData,
  setResetPassword,
  confirmPasswordRequest,
  form,
  validateData,
  apiUtil,
  match,
  history,
}) => {
  useEffect(() => {
    if (form && form.resetPasswordValid) {
      confirmPasswordRequest(() => {
        history.push(getRegPath("/signin"));
      });
      form.resetPasswordValid = false;
    }
    setResetPassword({
      resetUserEmail: window.atob(match.params.email.split(/'([^']+)/)[1]),
      otp: match.params.otp,
    });
    // eslint-disable-next-line
  }, [form]);

  return (
    <div className="container" style={{ marginTop: "10%", maxWidth: 400 }}>
      <h2 className="auth-header mb-5">
        Reset
        <br /> Password
      </h2>
      <Row>
        <div
          className="col-md-12 text-left mt-4"
          onKeyDown={event => {
            if (event.keyCode === 13) {
              validateData(resetPasswordData);
            }
          }}
        >
          <TextInput
            error={form.resetPassword}
            type={"password"}
            label="Password"
            value={resetPasswordData.resetPassword}
            onChange={val => setResetPassword({ resetPassword: val })}
          />
          <TextInput
            error={form.resetConfirmPassword}
            type={"password"}
            label="Confirm Password"
            value={resetPasswordData.resetConfirmPassword}
            onChange={val => setResetPassword({ resetConfirmPassword: val })}
          />
        </div>
      </Row>
      <div>
        <Button
          label={apiUtil.isLoading ? <SpinnerBorder /> : "Reset"}
          className="mb-4"
          onClick={() => validateData(resetPasswordData)}
        />
      </div>
    </div>
  );
};

const mapStoreToProps = ({ login, validation, api }) => ({
  resetPasswordData: login,
  form: validation.data,
  apiUtil: api,
});

const mapDispatchToProps = dispatch => ({
  setResetPassword: updatedData => dispatch(actions.setLoginData(updatedData)),
  validateData: resetPasswordData =>
    dispatch(actions.validateData(VALIDATE_RESET_PASSWORD, resetPasswordData)),
  confirmPasswordRequest: cb => dispatch(actions.confirmPasswordRequest(cb)),
});

export default withRouter(
  connect(mapStoreToProps, mapDispatchToProps)(ResetPassword)
);
